import { styled as muiStyled } from '@mui/material'

export const ProvedTechniquesListContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    justify-content: flex-start;
    gap: 20px;
    margin: 12px 0;
    color; #fff;
    .primary-text {
      font-size: 16px;
      font-weight: 600;
      margin: 0 0 8px 0;
    }
    .secondary-text {
      font-size: 14px;
      font-weight: 100;
      margin: 0;
    }
`,
)

export const ProvenTechniquesImage = muiStyled('img')(
  ({ theme }) => `
    width: 40px;
    height: 40px;
    object-fit: cover;
    margin-top: 7px;
    flex-shrink: 0;
`,
)
